var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-background"},[_c('main',{staticClass:"w-full"},[_c('div',{staticClass:"w-full p-3 sm:p-4"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }